import { clearAllBodyScrollLocks } from 'body-scroll-lock'
import { useEffect } from 'react'

export const clearBodyScrollLock = () => {
  clearAllBodyScrollLocks()

  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.bottom = ''
  document.body.style.overflow = ''
}

export const useClearBodyScrollLock = () => {
  useEffect(() => {
    return clearAllBodyScrollLocks
  }, [])
}
